var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.WOMs),function(wom,womIndex){return _c('global-state-aggregator-wom-watcher',{key:wom.$internals.metaProperties.meta.guid,attrs:{"WOM":wom},on:{"triggerReCalc":_vm.triggerReCalc}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }